import { motion } from "framer-motion";
import { ShieldCheck, RefreshCcw } from "lucide-react";

const FALLBACK = [
  { title: "Tatuagem Comercial / Flash Small", price: "A partir de R$ 350", details: "Arte até 8cm, traços finos ou símbolos. Duração ~1h30." },
  { title: "Sessão Custom (Projetos Médios)", price: "R$ 800 - R$ 1.500", details: "Arte autoral exclusiva de 10cm a 20cm. Duração de 3h a 5h." },
  { title: "Fechamento de Braço / Costas (Diária)", price: "R$ 2.200 por diária", details: "Sessão intensiva de 6h a 8h dedicada a grandes coberturas e fechamentos." },
  { title: "Cobertura (Cover-up) & Restauração", price: "Avaliação sob consulta", details: "Estudo de viabilidade gráfica para cobrir ou renovar tatuagens antigas." },
];

export const Services = ({ services, notice }) => {
  const list = services?.length ? services : FALLBACK;
  return (
    <section id="servicos" className="py-24 sm:py-32" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }} className="mb-14 max-w-2xl">
          <p className="font-mono-dt text-xs uppercase tracking-[0.35em] text-[#e03131] mb-4">Investimento</p>
          <h2 className="font-display font-bold uppercase tracking-tight text-2xl sm:text-4xl lg:text-5xl" data-testid="services-title">
            Serviços & <span className="text-outline">valores</span>
          </h2>
          {notice && (
            <p className="mt-5 inline-flex items-center gap-2 text-xs font-mono-dt uppercase tracking-[0.15em] text-[#c5a880] border border-[#c5a880]/30 rounded-full px-4 py-2" data-testid="services-notice">
              {notice}
            </p>
          )}
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {list.map((s, i) => (
            <motion.div key={s.title} data-testid={`service-card-${i}`}
              initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group relative rounded-lg border border-[#27272a]/70 bg-[#121215] p-7 hover:border-[#e03131]/50 transition-colors duration-500">
              <span className="font-mono-dt text-[10px] text-zinc-600 tracking-[0.3em]">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="font-display font-semibold text-lg sm:text-xl mt-3">{s.title}</h3>
              <p className="font-mono-dt text-sm text-[#e03131] mt-2 tracking-wide" data-testid={`service-price-${i}`}>{s.price}</p>
              <p className="text-sm text-zinc-400 mt-3 leading-relaxed">{s.details}</p>
            </motion.div>
          ))}
        </div>
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-10 flex flex-col sm:flex-row gap-4">
          {[
            [ShieldCheck, "Agulhas e tintas 100% descartáveis, autorizadas pela Anvisa"],
            [RefreshCcw, "Retoque gratuito garantido em até 60 dias"],
          ].map(([Icon, text]) => (
            <div key={text} className="flex items-center gap-3 text-sm text-zinc-400 border border-[#27272a]/60 rounded-md px-5 py-3.5 bg-[#0d0d10]">
              <Icon size={16} className="text-[#e03131] shrink-0" />{text}
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
